__turbopack_context__.v({
  "bulletPoints": "bBSemW_bulletPoints",
  "bulletPoints2": "bBSemW_bulletPoints2",
  "button": "bBSemW_button",
  "desc": "bBSemW_desc",
  "dialogClose": "bBSemW_dialogClose",
  "dialogContent": "bBSemW_dialogContent",
  "dialogCore": "bBSemW_dialogCore",
  "dialogTitle": "bBSemW_dialogTitle",
  "footer": "bBSemW_footer",
  "freeBox": "bBSemW_freeBox",
  "header": "bBSemW_header",
  "hiddenIfEmptyContainer": "bBSemW_hiddenIfEmptyContainer",
  "intro": "bBSemW_intro",
  "left": "bBSemW_left",
  "li___6ZCe": "bBSemW_li___6ZCe",
  "li__gQgf3": "bBSemW_li__gQgf3",
  "li__ghPt4": "bBSemW_li__ghPt4",
  "li__i4A4J": "bBSemW_li__i4A4J",
  "li__j8Jug": "bBSemW_li__j8Jug",
  "li__jkhW4": "bBSemW_li__jkhW4",
  "li__l47Xi": "bBSemW_li__l47Xi",
  "li__nBzNu": "bBSemW_li__nBzNu",
  "li__s3WBc": "bBSemW_li__s3WBc",
  "li__sEFhK": "bBSemW_li__sEFhK",
  "li__wn1Up": "bBSemW_li__wn1Up",
  "link": "bBSemW_link",
  "link___3EwYt": "bBSemW_link___3EwYt",
  "link__aQw2D": "bBSemW_link__aQw2D",
  "modal": "bBSemW_modal",
  "modalCloseButton": "bBSemW_modalCloseButton",
  "openProvider": "bBSemW_openProvider",
  "overlayMask": "bBSemW_overlayMask",
  "pcls_CmcAd0NOoyMp": "bBSemW_pcls_CmcAd0NOoyMp",
  "root": "bBSemW_root",
  "section": "bBSemW_section",
  "stack": "bBSemW_stack",
  "svg___7OoT": "bBSemW_svg___7OoT",
  "svg__ao02": "bBSemW_svg__ao02",
  "text__gYxi": "bBSemW_text__gYxi",
  "text__hwecz": "bBSemW_text__hwecz",
  "title": "bBSemW_title",
  "top": "bBSemW_top",
  "ul___5Pv0": "bBSemW_ul___5Pv0",
  "ul__bT3L": "bBSemW_ul__bT3L",
  "ul__ccpQi": "bBSemW_ul__ccpQi",
  "ul__dd08V": "bBSemW_ul__dd08V",
  "ul__g0Jjl": "bBSemW_ul__g0Jjl",
  "ul__hhdqx": "bBSemW_ul__hhdqx",
  "ul__kVs19": "bBSemW_ul__kVs19",
  "ul__pwnkN": "bBSemW_ul__pwnkN",
  "ul__qd75C": "bBSemW_ul__qd75C",
  "ul__uooNw": "bBSemW_ul__uooNw",
  "ul__xuwQe": "bBSemW_ul__xuwQe",
});
